import React, { FunctionComponent } from 'react';

import { RotationNumbersProps } from '@Containers/UserCallerIds/AbstractRotationCallerIds/AbstractSystemNumbersModal/AbstractSystemNumbersModal.types';
import { VoiceProvider } from '@Models/callerIds.models';

import AbstractRotationNumbersContainer from '../../AbstractRotationCallerIds/AbstractRotationNumbersMain';

const TelnyxRotationNumbersContainer: FunctionComponent<RotationNumbersProps> =
  (props: RotationNumbersProps): JSX.Element => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { isAdmin } = props;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    return (
      <AbstractRotationNumbersContainer
        isAdmin={isAdmin}
        provider={VoiceProvider.TELNYX}
      />
    );
  };

export default TelnyxRotationNumbersContainer;
